import styled from "styled-components";

const LandingWrapper = styled.main`
  /* border: 2px solid red; */
  max-width: 1300px;
  margin-inline: auto;
  padding: 2rem 4vw;
  height: 100vh;

  .summary__con {
    height: 95%;
    display: flex;
    align-items: center;
  }

  .summary__con > summary {
    /* border: 2px solid red; */
    height: fit-content;
    display: flex;
    align-items: center;
  }

  .logo__con {
    display: flex;
    align-items: center;
  }

  .landing__content__and__img {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .landing__content {
    /* border: 2px solid red; */
    width: 45%;
  }

  .landing__content > p:first-child {
    font-size: 2.8rem;
    font-weight: 600;
  }
  .landing__content > p:first-child span {
    color: var(--dark);
  }
  .landing__content > p:nth-child(2) {
    margin-block: 20px;
  }

  .landing__img {
    /* border: 2px solid blue; */
    width: 45%;
    height: 70vh;
  }
  .landing__img img {
    /* border: 2px solid blue; */
    width: 100%;
    height: 100%;
  }
  @media screen and (max-height: 650px) {
    /* border: 2px solid yellow; */
    height: fit-content;
    .landing__img {
      height: 60%;
    }
  }
  @media screen and (max-width: 990px) {
    min-height: 100vh;

    .summary__con {
      min-height: 60vh;
    }

    .summary__con > summary {
      align-self: flex-start;
      margin-top: 15vh;
    }

    .landing__content {
      width: 80%;
    }
    .landing__img {
      display: none;
    }
  }
  @media screen and (max-width: 600px) {
    .landing__content {
      width: 95%;
    }
    .landing__content > p:first-child {
      font-size: 6.5vw;
    }
  }
  @media screen and (max-width: 500px) {
    .landing__content > p:nth-child(2) {
      font-size: 14px;
    }
  }
`;

export default LandingWrapper;
